import React from "react";
import Sidebar from "../Sidebar";
import styles from "./TwoColumnLayout.module.css";
import { mcn } from "utils/mergeClassnames";

interface Props {
  children: React.ReactElement;
  sidebar?: React.ReactElement;
  transparent?: boolean;
  isResponsiveFixes?: boolean;
}

function TwoColumnLayout(props: Props) {
  const { children, sidebar, transparent, isResponsiveFixes } = props;

  return (
    <section className={mcn(styles.root, isResponsiveFixes && styles.rootRes)}>
      <div className={mcn(styles.content, isResponsiveFixes && styles.contentRes)}>{children}</div>
      {!isResponsiveFixes ? (
        <div className={styles.sidebar}>
          <Sidebar transparent={transparent}>{sidebar}</Sidebar>
        </div>
      ) : null}
    </section>
  );
}

export default TwoColumnLayout;
